import { EyeInvisibleOutlined } from "@ant-design/icons";
import { Tag, Tooltip } from "antd";
import React from "react";
import { HTMLProps } from "../model/HTMLProps";
import { OfferingCommonDetails } from "./Offering";

interface OfferingHiddenFromListingBadgeProps extends HTMLProps {
  offering: OfferingCommonDetails;
}

export function OfferingHiddenFromListingBadge(
  props: OfferingHiddenFromListingBadgeProps
) {
  if (!props.offering.isHiddenFromListing) {
    return null;
  }

  return (
    <Tag
      icon={<EyeInvisibleOutlined />}
      color="default"
      className={props.className}
    >
      <Tooltip
        title={`Accessible via only link${
          props.offering.publishedAt ? "" : " (once published)"
        }`}
      >
        <span className="fs-14">Hidden on profile</span>
      </Tooltip>
    </Tag>
  );
}
